import { useEffect, useState } from "react";
import { getUrlQuerysection } from "../../../../helpers";
import {
  useGetExpenseCategories,
  useGetExpenseDepartments,
  useGetExpenses,
} from "../../../../hooks/api/queries/useExpenses";
import { useStoreCurrency } from "../../../../hooks/useStoreCurrency";
import { useSelector } from "react-redux";
import { useUrlSearch } from "../../../../hooks/useUrlSearch";

const useExpenses = () => {
  const queries = getUrlQuerysection();
  const {
    search,
    setSearch,
    gotoPage,
    filterByStoreId,
    filterBySearch,
    filterByKey,
  } = useUrlSearch();
  const [isCreateExpense, setIsCreateExpense] = useState(
    search.get("isCreateExpense") === "true" ? true : false,
  );
  const [isExpenseOption, setIsExpenseOption] = useState(false);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { storeHasMultipleCurrency } = useStoreCurrency();
  const [currentStore, setCurrentStore] = useState(
    storeHasMultipleCurrency ? search.get("store_id") || storeList[0]?.id : "",
  );
  const {
    isLoading: isFetchingExpenses,
    data: expenses,
    refetch: handleFetchExpenses,
  } = useGetExpenses(queries);

  const { isLoading: isLoadingExpenseCategories, data: expenseCategories } =
    useGetExpenseCategories();
  const { data, isLoading: isLoadingDepartments } = useGetExpenseDepartments(
    {},
  );

  useEffect(() => {
    if (storeList?.length > 0 && storeHasMultipleCurrency) {
      search.set("store_id", storeList[0]?.id);
      setSearch(search, { replace: true });
    }
  }, [storeList, storeHasMultipleCurrency]);

  const filterByCategoryId = (categoryId) => {
    filterByKey("category_id", categoryId);
  };

  const isRecurringTab = search.get("is_recurring") === "true";

  const filterByRecurring = (isRecurring) => {
    filterByKey("is_recurring", isRecurring ? "true" : "false");
  };

  return {
    isFetchingExpenses:
      isLoadingExpenseCategories || isFetchingExpenses || isLoadingDepartments,
    metaDetails: expenses?.meta || {},
    search,
    storeList,
    storeHasMultipleCurrency,
    isCreateExpense,
    expenses: expenses?.data || [],
    currentStore,
    expenseCategories: expenseCategories || [],
    expenseDepartments: data?.data || [],
    isExpenseOption,
    isRecurringTab,
    filterByKey,
    setIsExpenseOption,
    filterByCategoryId,
    filterByRecurring,
    setCurrentStore,
    filterByStoreId,
    setIsCreateExpense,
    handleFetchExpenses,
    gotoPage,
    searchExpenses: filterBySearch,
  };
};

export default useExpenses;
